

<template>
  <div id="app">
    <!-- 顶部图插槽 -->
    <headView /> 
    <!-- 导航栏插槽 -->  
    <!-- 主内容区域插槽 -->
    <main>
      <div class="wf-wrap">
        <div class="wf-container">
          <slot></slot> <!-- 默认插槽，用于放置主要内容 -->
        </div>
      </div>
    </main>
    
    <!-- 底部插槽 -->
    <footView />
    <BtnNav />
    
    <ScrollModel />
    <!-- <footer>
      <p>&copy; 2023 我们的公司. All rights reserved.</p>
      <slot name="footer"></slot>
    </footer> -->
    

  </div>
</template>

<script setup>
import HeadView from '@/components/HeadView.vue'
import FootView from '@/components/FootView.vue'
import ScrollModel from '@/components/ScrollModel.vue' 
import BtnNav from '@/components/BtnNav.vue'

</script>



<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; 

  display: -ms-grid;
  display: grid;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
  -ms-grid-columns: 100%;
  grid-template-columns: 100%;
  grid-template-areas:
  "header"
  "slider"
  "title"
  "fancyheader"
  "checkout"
  "main"
  "footer";   
}
html, body, body.page, .wf-container>* {
    font: normal 15px / 27px "Roboto", Helvetica, Arial, Verdana, sans-serif;
    word-spacing: normal;
    color: #b6b6c1;
}

main{
  min-height: 60vh; 
  background: #020221 url(@/assets/bg.jpg) repeat center center;
  grid-area: main; 
  padding: 20px 0 60px 0;
}
.wf-wrap{
  position: relative;
  width: 1300px;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}
.wf-container{ 
  position: relative;
  /* background-image: url(https://odausprod.wpengine.com/wp-content/uploads/2022/04/8-2.jpg?id=7193) !important; */
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  -webkit-transition: opacity .5s ease;
  -o-transition: opacity .5s ease;
  transition: opacity .5s ease;
  overflow: hidden;
}
</style>